// Progress bar for Marketo forms
export default function progressBar(type) {
    let form = document.querySelector('.form');
    if (form) {
        let $progressBar = $('.progress-bar > div');
        let $progressNum = $('.form-completion .completed');
        let $fieldNum    = $('.form-completion .total-fields');
        let $fields      = $('div.mktoFormRow');
        let $submitBtn   = $('button.mktoButton');

        // set number of editable fields, adjust if needed
        let editable;
        let width = 0;
        let completed = 0;

        if (type === 'hero') {
            editable = 8;
        } else if (type === 'resource') {
            editable = 7;
        }

        function adjustProgress(width, field) {
            let value = (width / (editable - 1)) * 100;
            $progressBar.css({"width": value + "%" });
            $progressNum.html(Math.floor(value) + "% completed");
            if (type === 'hero') {
                $fieldNum.html(field + ' / 7 fields');
                if (value === 100) {
                    $submitBtn.css({'background-color': '#E424FF', 'color': 'white', 'border': '1px solid #E424FF'}); // NetApp pink
                } else {
                    $submitBtn.css({'background-color': 'white', 'color': 'black', 'border': '1px solid black'});
                }
            } else if (type === 'resource') {
                $fieldNum.html(field  + ' / 6 fields');
                if (value === 100) {
                    $submitBtn.css({'background-color': '#0054D7', 'color': 'white', 'border': '1px solid #0054D7'}); // NetApp blue
                } else {
                    $submitBtn.css({'background-color': 'white', 'color': 'black', 'border': '1px solid black'});
                }
            }
        }

        $fields.each(function(i) {
            if (i < editable) {
                // Inputs
                if (i < 5) {
                    let $input = $(this).find('input');
                    let edited = false;
                    $input.on('input', function() {
                        if (!$input.val() && edited) {
                            width--;
                            completed--;
                            adjustProgress(width, completed);
                            edited = false;
                        } else if (!edited) {
                            width++;
                            completed++;
                            adjustProgress(width, completed);
                            edited = true;
                        }
                    })
                }
                // Country select
                if (i === 5) {
                    let $select = $(this).find('select');
                    let edited = false;
                    $select.change(function() {
                        if ($select.val() === '' && edited) {
                            width--;
                            completed--;
                            adjustProgress(width, completed);
                            edited = false;
                        } else if (!edited) {
                            width++;
                            completed++;
                            adjustProgress(width, completed);
                            edited = true;
                        }
                    })
                }
                // textarea "How can we help?"
                if (i === 6) {
                    let $textarea = $(this).find('textarea');
                    let edited = false;
                    $textarea.on('input', function() {
                        if ($textarea.val() === '' && edited) {
                            width--;
                            completed--;
                            adjustProgress(width, completed);
                            edited = false;
                        } else if (!edited) {
                            width++;
                            completed++;
                            adjustProgress(width, completed);
                            edited = true;
                        }
                    })
                }
            }
        })
    }
}